/* eslint-disable no-underscore-dangle */
import { compassColors } from "@utils/styling";
import { drawLabelBox } from "src/utils/graphs/common/chartElements";

export function drawLabel(
  chartInstance,
  text,
  tick,
  startTick,
  endTick,
  color = compassColors.tarocco,
  { dataset } = { dataset: 1 }
) {
  if (tick < startTick) {
    return;
  }
  const { ctx, width } = chartInstance;
  ctx.save();
  ctx.textAlign = "center";
  ctx.fillStyle = color;

  const fontSize = width <= 350 ? 10 : 12;
  ctx.font = `${fontSize}pt 'Brown LL', sans-serif`;
  const textUpper = text.toUpperCase();

  if (tick > endTick) {
    const textWithArrow = `${textUpper} →`;
    const textMeasurement = ctx.measureText(textWithArrow);
    ctx.fillText(textWithArrow, width - textMeasurement.width / 2 - 20, 30);
  } else {
    const dataPointsOnLine = chartInstance._sortedMetasets[dataset].data;
    const dataPointToDrawRelativeTo = dataPointsOnLine[tick];

    const textMeasurement = ctx.measureText(textUpper);
    const crossBrowserBoundingBoxDescent =
      textMeasurement.fontBoundingBoxDescent ||
      textMeasurement.actualBoundingBoxDescent;
    const crossBrowserBoundingBoxAscent =
      textMeasurement.fontBoundingBoxAscent ||
      textMeasurement.actualBoundingBoxAscent;
    const textHeight =
      crossBrowserBoundingBoxDescent + crossBrowserBoundingBoxAscent;
    const pad = 18; // some hard coded value
    const xOffset = textMeasurement.width / 2 + pad;

    const yCoord = dataPointToDrawRelativeTo.y + 3;

    const endDatapoint = dataPointsOnLine[endTick]; // This gets us the xcoord of the goal label box which we should avoid overlapping with

    const collideX =
      dataPointToDrawRelativeTo.x + textMeasurement.width + pad >
      endDatapoint.x - 30; // The 30 should probably represent the width of the goal rectangle
    const collideY = yCoord + textHeight > endDatapoint.y - 55; // 55 is the rough height of the goal box
    const flip = collideX && collideY;

    ctx.fillText(
      textUpper,
      dataPointToDrawRelativeTo.x + (flip ? -xOffset : xOffset),
      yCoord
    );
  }
  ctx.restore();
}

export function renderGoal(
  chartInstance,
  topText,
  bottomText,
  tick,
  color = compassColors.tarocco,
  { dataset } = { dataset: 0 }
) {
  const { ctx, width } = chartInstance;
  const fontSize = width <= 350 ? 10 : 12;
  ctx.save();
  ctx.textAlign = "center";
  ctx.fillStyle = color;
  const dataPointsOnLine = chartInstance._sortedMetasets[dataset].data;
  const dataPointToDrawRelativeTo = dataPointsOnLine[tick];

  drawLabelBox({
    ctx,
    text: [topText.toUpperCase(), bottomText.toUpperCase()],
    x: dataPointToDrawRelativeTo.x,
    y: dataPointToDrawRelativeTo.y - 13,
    color,
    fontSize,
    padding: 8,
  });
  ctx.restore();
}
